import { FC, memo } from 'react';

import FieldEntry from '../../../../../components/FieldEntry';
import FieldEntryWrapper from '../../../../../components/FieldEntryWrapper/FieldEntryWrapper';
import PreviewSection from '../../../../../components/previewSection/PreviewSection';
import { messages } from './FinanceSection.messages';
import { FinanceSectionProps } from './FinanceSection.types';

const FinanceSection: FC<FinanceSectionProps> = (props) => {
    const { contactData } = props;

    const hasFilledValue = contactData.currencyCode;

    if (!hasFilledValue) {
        return null;
    }

    return (
        <PreviewSection header={messages.header}>
            <div>
                {/*
                TODO: vendor: add under certain conditions
                <FieldEntryWrapper>
                    <FieldEntry
                        title={messages.businessID}
                        value={contactData.businessNumber}
                    />
                </FieldEntryWrapper> */}

                {/*
                BACKEND DOESN'S SUPPORT THIS FIELD YET
                <FieldEntryWrapper>
                    <FieldEntry
                        title={messages.defaultExpenseAccount}
                        value={contactData.account?.text}
                    />
                </FieldEntryWrapper> */}

                {contactData.currencyCode && (
                    <FieldEntryWrapper>
                        <FieldEntry title={messages.baseCurrency} value={contactData.currencyCode} />
                    </FieldEntryWrapper>
                )}
            </div>
        </PreviewSection>
    );
};

export default memo(FinanceSection);
